import React from 'react';
import { useTranslation } from 'react-i18next';

import { useTheme } from '@/theme';
import { Flex, Text } from '@/components/ui';
import { i18nKeys } from '@/i18n/i18nKeyGen';
import CompanyUsersReadOnlyTable, {
  type CompanyUserDisplay,
} from '@/pages/admin/CompanyUsersReadOnlyTable';
import CompanySubscriptionHistorySection from './CompanySubscriptionHistorySection';

interface CompanyAdminDetailPanelProps {
  companyId: number;
  users: CompanyUserDisplay[];
}

const CompanyAdminDetailPanel: React.FC<CompanyAdminDetailPanelProps> = ({ companyId, users }) => {
  const { t } = useTranslation(['company', 'auth', 'common']);
  const { theme } = useTheme();

  const sectionTitleStyle: React.CSSProperties = {
    marginBottom: theme.spacing[3],
  };

  return (
    <Flex
      direction="column"
      gap={6}
      align="stretch"
      data-tour="company-subscription"
      style={{
        paddingLeft: theme.spacing[8],
        paddingRight: theme.spacing[8],
      }}
    >
      <CompanySubscriptionHistorySection companyId={companyId} />

      <section>
        <Text size="md" weight="semibold" style={sectionTitleStyle}>
          {t(i18nKeys.auth.usersList)}
        </Text>
        {users.length === 0 ? (
          <Text size="sm" color={theme.colors.text.secondary}>
            {t(i18nKeys.auth.noUsersRegistered)}
          </Text>
        ) : (
          <CompanyUsersReadOnlyTable users={users} />
        )}
      </section>
    </Flex>
  );
};

export default CompanyAdminDetailPanel;
